import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services';

/**
 * Route guard that prevents access to protected routes when the user
 * is not authenticated.
 *
 * If authentication fails, navigation is redirected to the root route.
 *
 * @returns `true` when access is allowed, or a `UrlTree` to redirect
 * the user when access is denied.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const AuthenticationGuard: CanActivateFn = () => {
  const router = inject(Router);
  const isAuthenticated = inject(AuthService).isAuthenticated;

  if (!isAuthenticated()) {
    return router.parseUrl('/');
  }

  return true;
};
